import React from "react";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { useHistory, useLocation } from "react-router-dom";
import { LoaderScreen } from "../../components/LoaderScreen";
import { useEffect, useState } from "react";
import request from "../../../Helpers/API";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { ChartPastel } from "./ChartPastel";
import { ProyeccionMensualScreen } from "./ProyeccionMensualScreen";
import Swal from "sweetalert2";
import FiltroDashboardCobranza from "./Components/FiltroDashboardCobranza";
import { useBox } from "./helper/useBox";
import { GetKey } from "../ReporteCobranza/Actions/GetContainer";
import { GetMonthName } from "../../helpers/GetMonthName";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { DashboardCobranzaHeader } from "./DashboardCobranzaHeader";
import { ChartPedidosFacturados } from "./ChartPedidosFacturados";
import { ChartClientesJuridico } from "./ChartClientesJuridico";
import { ChartMensajesAutomaticos } from "./ChartMensajesAutomatios";
import { ChartGestionCobranza3 } from "./ChartGestionCobranza3";
import { ChartRecuperacion2 } from "./ChartRecuperacion2";
import { ChartComportamiento2 } from "./ChartComportamiento2";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import { ChartMensajesAutomaticosOriginal } from "./ChartMensajesAutomaticosOriginal";
import { ChartCondonacionIntereses } from "./ChartCondonacionIntereses";
import { ChartPrestamosClientes } from "./ChartPrestamosClientes";

export const DashboardCobranzaScreen2 = () => {
  const history = useHistory();
  const [permiso, setPermiso] = useState();
  const [dataHeader, setDataHeader] = useState(null);
  const [dataTotal, setDataTotal] = useState(null);
  const [dataTotalEstados, setDataTotalEstados] = useState(null);
  const [dataRecuperacion, setDataRecuperacion] = useState(null);
  const [dataGestion, setDataGestion] = useState(null);
  const [dataPedidos, setDataPedidos] = useState(null);
  const [dataJuridico, setDataJuridico] = useState(null);
  const [dataMensajes, setDataMensajes] = useState(null);
  const [dataProyeccion, setDataProyeccion] = useState(null);
  const [dataProyeccionLinea, setDataProyeccionLinea] = useState(null);
  const [columnas, setColumnas] = useState(null);
  const [dataPorcRecuperacion, setDataPorcRecuperacion] = useState(null);
  const [titulo, setTitulo] = useState("DASHBOARD DE COBRANZA");
  const storedState = JSON.parse(localStorage.getItem("state")) || {};
  const [newEjercicio, setNewEjercicio] = useState(null);
  const [sucursalesPermitidas, setScurusalesPermitidas] = useState(null);
  const [newPeriodo, setNewPeriodo] = useState(null);
  const [ultimaActualizacion, setUltimaActualizacion] = useState(null);
  const [openHelp, setOpenHelp] = useState(false);
  const [cartera_transito, setCartera_transito] = useState({ saldo: 0, registros: 0 });
  const [interesesCondonados, setInteresesCondonados] = useState(null);
  const [prestamosClientes, setPrestamosClientes] = useState(null);

  // const [state, setState] = useState({ ejercicio: 2024, periodo: 12 })

  const [ocultoSuperior, setOcultoSuperior] = useState(false);

  const [isMax, setIsMax] = useState(false);

  const [boxstate, setBoxState] = useBox();

  const toggleMax = () => {
    setIsMax(!isMax);
  };

  useEffect(() => {
    request
      .get(`PermisoCobranza/GetPermiso`)
      .then((result) => {
        setPermiso(result.permiso);
      })
      .catch((error) => {
        Swal.fire("MENUS COBRANZA", JSON.stringify(error), "error");
      });
  }, []);

  const [stateFiltro, setStateFiltro] = useState(() => ({
    ejercicio: storedState.ejercicio || boxstate.ejercicio,
    adr: Array.isArray(storedState.adr)
      ? storedState.adr
        .filter((item) => item.checked)
        .map(({ idadr, adr }) => ({ idadr, adr }))
      : boxstate.pv.adr || [],
    sucursal: Array.isArray(storedState.sucursal)
      ? storedState.sucursal
        .filter((item) => item.checked)
        .map(({ idsucursal, sucursal }) => ({ idsucursal, sucursal }))
      : boxstate.pv.sucursal || [],
  }));

  useEffect(() => {
    const hasStoredAdr =
      Array.isArray(storedState?.adr) &&
      storedState.adr.some((item) => item.checked);
    const hasStoredSucursal =
      Array.isArray(storedState?.sucursal) &&
      storedState.sucursal.some((item) => item.checked);

    const adrFinal = boxstate.pv?.adr?.length
      ? boxstate.pv.adr
      : hasStoredAdr
        ? storedState.adr
          .filter((item) => item.checked)
          .map(({ idadr, adr }) => ({ idadr, adr }))
        : [];

    const sucursalFinal = boxstate.pv?.sucursal?.length
      ? boxstate.pv.sucursal
      : hasStoredSucursal
        ? storedState.sucursal
          .filter((item) => item.checked)
          .map(({ idsucursal, sucursal }) => ({ idsucursal, sucursal }))
        : [];

    setStateFiltro({
      ejercicio: storedState.ejercicio || boxstate.ejercicio,
      adr: adrFinal,
      sucursal: sucursalFinal,
    });
  }, [boxstate]);

  const ocultarSuperior = () => {
    setOcultoSuperior(!ocultoSuperior);
  };

  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });

  const onRegresar = () => {
    localStorage.removeItem("state");
    history.push("/Creditoycobranza/Main");
  };

  useEffect(() => {
    setNewEjercicio(storedState.ejercicio);
    setNewPeriodo(storedState.periodo);
  }, [storedState]);

  useEffect(() => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(`PermisoCobranza/GetSucursales`)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setScurusalesPermitidas(result);
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("CONVENIO PAGO", JSON.stringify(error), "error");
      });
  }, []);

  useEffect(() => {
    if (sucursalesPermitidas && sucursalesPermitidas.length > 0) {
      const newEjercicio = storedState.ejercicio || new Date().getFullYear();
      const newPeriodo = storedState.periodo || new Date().getMonth() + 1;

      setBoxState((prevState) => ({
        ...prevState,
        ejercicio: newEjercicio,
        periodo: newPeriodo,
      }));

      onExecute(newEjercicio, newPeriodo, "CC");
    }
  }, [sucursalesPermitidas]);

  const onExecute = async (ejercicio, periodo, responsable) => {
    let sucursales = GetKey(stateFiltro.sucursal, ["idsucursal"]);
    let adr = GetKey(stateFiltro.adr, ["idadr"]);
    const cantidadAdr = Array.isArray(stateFiltro.adr)
      ? stateFiltro.adr.length
      : 0;

    // Si no hay sucursales seleccionadas
    if (!sucursales || sucursales.length === 0) {
      if (cantidadAdr === 0 || cantidadAdr === 2) {
        // Usa todas las sucursales permitidas
        sucursales = GetKey(sucursalesPermitidas, ["idsucursal"]);
      } else if (cantidadAdr === 1) {
        // Filtra sucursales que terminan con el adr seleccionado
        const adrSeleccionado = stateFiltro.adr[0].idadr;
        const sucursalesFiltradas = sucursalesPermitidas.filter(
          ({ idsucursal }) => {
            const ultimoDigito = Number(String(idsucursal).slice(-1));
            return ultimoDigito === Number(adrSeleccionado); // Asegura que ambos sean números
          },
        );

        sucursales = GetKey(sucursalesFiltradas, ["idsucursal"]);
      }
    }

    // Validación final por seguridad
    if (!sucursales || sucursales.length === 0) {
      sucursales = GetKey(sucursalesPermitidas, ["idsucursal"]);
    }

    if (adr === undefined || adr === null || adr === "") {
      adr = "0";
    }

    try {
      setLoader({ ...loader, mostrar: true });

      // Define todas las solicitudes
      const requests = [
        request.get(
          `DashboardIndicadoresGraficas/ObtenerInfoGraficas?ejercicio=${ejercicio}&periodo=${periodo}&adr=${adr}&sucursales=${sucursales}&responsable=${responsable}`,
        ),
      ];

      // Ejecuta todas las solicitudes en paralelo
      const [result1] = await Promise.all(requests);

      setDataHeader(result1.header);
      setDataTotal(result1.total);
      setDataTotalEstados(result1.total_estados);
      setDataRecuperacion(result1.recuperacion);
      setDataGestion(result1.gestion);
      setDataPedidos(result1.pedidos);
      setDataJuridico(result1.juridico);
      setDataMensajes(result1.mensajes);
      setDataProyeccion(result1.listado);
      setDataProyeccionLinea(JSON.parse(result1.tipo_cartera));
      setColumnas(result1.columnas.split(","));
      setUltimaActualizacion(result1.ultima_actualizacion);
      setDataPorcRecuperacion(result1.porc_recuperacion);
      setCartera_transito(result1.cartera_transito)
      setInteresesCondonados(result1.intereses_condonados)
      setPrestamosClientes(result1.prestamos_clientes)

      // setScurusalesPermitidas(result1.permisos)
      // setDataComportamiento(result2.comportamiento);

      setTitulo(
        `DASHBOARD DE COBRANZA ${GetMonthName(
          periodo,
        ).toUpperCase()} ${ejercicio}`,
      );

      setLoader({ ...loader, mostrar: false });
    } catch (error) {
      setLoader({ ...loader, mostrar: false });
      Swal.fire("Error", "Ocurrió un error al cargar los datos.", "error");
    }
  };

  const onGeneraPDF = async () => {
    const tituloElement = document.querySelector(".plantilla-screen-header");
    const dashboardElement = document.querySelector(
      ".dashboard-cobranza-container",
    );
    // const dashboardElement = document.querySelector(".dashboard-cobranza-container");
    if (!tituloElement || !dashboardElement) {
      Swal.fire(
        "Error",
        "No se encontraron las secciones a capturar.",
        "error",
      );
      return;
    }

    // Guardar dimensiones originales
    const originalWidth = dashboardElement.scrollWidth;
    const originalHeight = dashboardElement.scrollHeight;

    // Quitar temporalmente el box-shadow de los elementos con clase .chart
    const charts = dashboardElement.querySelectorAll(".chart");
    charts.forEach((chart) => {
      chart.style.boxShadow = "none";
    });

    // Establece el tamaño completo del contenedor
    dashboardElement.style.width = `${originalWidth}px`;
    dashboardElement.style.height = `${originalHeight}px`;
    setLoader({ ...loader, mostrar: true });

    try {
      // Capturar el título por separado
      const tituloCanvas = await html2canvas(tituloElement);

      // Capturar el contenido principal del dashboard por separado
      const dashboardCanvas = await html2canvas(dashboardElement, {
        width: originalWidth,
        height: originalHeight,
        windowWidth: originalWidth,
        windowHeight: originalHeight,
        scrollX: -window.scrollX,
        scrollY: -window.scrollY,
      });

      charts.forEach((chart) => {
        chart.style.boxShadow = "2px 2px 5px #ccc"; // Cambia este valor si tu estilo original es diferente
      });

      // Restaurar dimensiones originales si se modificaron
      dashboardElement.style.width = "";
      dashboardElement.style.height = "";

      // Usando jsPDF para generar el PDF
      const pdf = new jsPDF();

      // Añadir la captura del título al PDF
      const tituloImage = tituloCanvas.toDataURL("image/png");
      const tituloProps = pdf.getImageProperties(tituloImage);
      const imgWidth = 210; // Ancho de página en mm (A4)
      const escala = 1.5; // Escala para agrandar el título
      const tituloHeight =
        ((tituloProps.height * imgWidth) / tituloProps.width) * escala;
      pdf.addImage(tituloImage, "PNG", -20, 4, imgWidth + 40, tituloHeight);

      // Añadir la captura del dashboard debajo del título
      const dashboardImage = dashboardCanvas.toDataURL("image/png");
      const dashboardProps = pdf.getImageProperties(dashboardImage);
      const dashboardHeight =
        (dashboardProps.height * imgWidth) / dashboardProps.width;
      pdf.addImage(
        dashboardImage,
        "PNG",
        0,
        tituloHeight + 4,
        imgWidth,
        dashboardHeight,
      );

      // Descargar el archivo PDF
      pdf.save(`DashboardCobranza.pdf`);
      setLoader({ ...loader, mostrar: false });
    } catch (error) {
      setLoader({ ...loader, mostrar: false });
      console.error("Error al capturar las secciones:", error);
      Swal.fire("Error", "Ocurrió un error al generar el PDF.", "error");
    }
  };
  const clickRuta = () => {
    localStorage.setItem("ruta", "/Creditoycobranza/DashboardCobranza");
    history.push("/Creditoycobranza/ResumenCartera", sucursalesPermitidas);
  };

  const formatActualizacion = (data) => {
    const fecha = new Date(data.fecha_actualizacion);

    // Formatear día, mes, año
    const dia = String(fecha.getDate()).padStart(2, "0");
    const mes = String(fecha.getMonth() + 1).padStart(2, "0"); // los meses van de 0 a 11
    const anio = fecha.getFullYear();

    // Formatear hora y minutos
    const horas = String(fecha.getHours()).padStart(2, "0");
    const minutos = String(fecha.getMinutes()).padStart(2, "0");

    // Combinar todo
    const fechaFormateada = `${dia}/${mes}/${anio} a las ${horas}:${minutos}`;
    return fechaFormateada;
  };

  // console.log(formatActualizacion(ultimaActualizacion[0]))

  return (
    <PlantillaScreen
      titulo={titulo}
      className_main={1}
      className={"dashboard-cobranza2"}
    >
      <LoaderScreen loader={loader} />
      <div className="dashboard-cobranza-actions">
        {permiso === "Menu" && (
          <div
            className="dashboard-cobranza-actions-regresar"
            onClick={onRegresar}
          >
            <ArrowBackIcon /> Regresar
          </div>
        )}
        <div
          className={
            permiso === "Menu"
              ? "dashboard-cobranza-actions-filtro"
              : "dashboard-cobranza-actions-filtro-sinregresar"
          }
        >
          <FiltroDashboardCobranza
            onExecute={onExecute}
            boxState={boxstate}
            onBoxChange={setBoxState}
            sucursales={sucursalesPermitidas}
          />
        </div>
        <div className="buttons">
          <button
            className="PDF"
            onClick={() => onGeneraPDF()}
            style={{ backgroundColor: "#940404" }}
          >
            PDF
          </button>

          <button className="ayuda" onClick={() => setOpenHelp(!openHelp)}>
            <HelpOutlineOutlinedIcon /> Ayuda
          </button>

          {openHelp && (
            <div className="popover-help">
              <div className="arrow"></div>

              <div className="popover-titulo">
                <div className="popover-header">
                  <div className="popover-header-titulo">{"Ayuda"}</div>
                </div>
                <div className="plantilla-screen-efecto">
                  <div className="plantilla-screen-efecto-bl"></div>
                  <div className="plantilla-screen-efecto-circle"></div>
                  <div className="plantilla-screen-efecto-br"></div>
                </div>
              </div>

              <p className="texto">
                Los siguientes indicadores hacen referencia a una cartera
                dependiendo el color mostrado:
              </p>

              <div className="indicadores">
                <div className="fila">
                  <span className="circulo verde"></span>
                  <span className="label-texto-asd">Cartera Activa</span>
                </div>

                <div className="fila">
                  <span className="circulo amarillo"></span>
                  <span className="label-texto-asd">Cartera por Vencer</span>
                </div>

                <div className="fila">
                  <span className="circulo rojo"></span>
                  <span className="label-texto-asd">Cartera Vencida</span>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="dashboard-cobranza-container scroll-4">
        {dataHeader && (
          <DashboardCobranzaHeader
            data={dataHeader}
            dataConveniado={dataGestion}
            sucursales={sucursalesPermitidas}
          />
        )}
        {dataTotal &&
          dataRecuperacion &&
          dataGestion &&
          dataProyeccion &&
          dataProyeccionLinea &&
          columnas &&
          dataPedidos &&
          dataJuridico &&
          dataMensajes &&
          dataPorcRecuperacion && (
            <>
              <div className="fila superior">
                <div
                  className={`chart cuarto`}
                  onClick={() =>
                    history.push(
                      "/Creditoycobranza/ReporteRecuperacionCompleta",
                      sucursalesPermitidas,
                    )
                  }
                >
                  <div className="chart-header">
                    <div className="chart-titulo">Comportamiento de saldos</div>
                  </div>
                  <div className="chart-info">
                    <ChartComportamiento2
                      data={dataTotalEstados}
                      ejercicio={newEjercicio || boxstate.ejercicio}
                      periodo={newPeriodo || boxstate.periodo}
                    />
                  </div>
                </div>
                <div
                  className="chart tercero"
                // onClick={() =>
                //   history.push(
                //     "/Creditoycobranza/ReporteRecuperacionCompleta"
                //   )
                // }
                >
                  <div className="chart-header">
                    <div className="chart-titulo">Recuperación</div>
                  </div>
                  <div className="chart-info">
                    <ChartRecuperacion2
                      data={dataRecuperacion}
                      ejercicio={newEjercicio || boxstate.ejercicio}
                      periodo={newPeriodo || boxstate.periodo}
                      sucursales={sucursalesPermitidas}
                    />
                  </div>
                </div>

                <div className="chart primero" onClick={clickRuta}>
                  <div className="chart-titulo">Resumen</div>
                  <div className="chart-info">
                    <ChartPastel
                      datos={dataTotal}
                      ejercicio={newEjercicio || boxstate.ejercicio}
                      periodo={newPeriodo || boxstate.periodo}
                      datosTotal={dataHeader}
                    />
                  </div>
                </div>

                <div
                  className="chart segundo"
                // onClick={() =>
                //   history.push(
                //     "/Creditoycobranza/GestionClientes", {
                //     permisos: sucursalesPermitidas
                //   }
                //   )
                // }
                >
                  <div className="chart-titulo">Gestión</div>
                  <div className="chart-info">
                    <ChartGestionCobranza3
                      data={dataGestion}
                      ejercicio={newEjercicio || boxstate.ejercicio}
                      periodo={newPeriodo || boxstate.periodo}
                      sucursales={sucursalesPermitidas}
                    />
                    {/* <ChartBarra2 datos={dataComportamientoResponsable} ejercicio={newEjercicio || boxstate.ejercicio} periodo={newPeriodo || boxstate.periodo} /> */}
                  </div>
                </div>
                {permiso === "Menu" && (
                  <>
                    {/* <div
                      className="chart quinto"
                      onClick={() =>
                        history.push(
                          "/Creditoycobranza/PedidosFacturados",
                          {
                            permisos: sucursalesPermitidas
                          }
                        )
                      }
                    >
                      <div className="chart-titulo">Facturación</div>
                      <div className="chart-info">
                        <ChartPedidosFacturados data={dataPedidos} />
                      </div>
                    </div> */}

                    <div
                      className="chart quinto condonacion-intereses-chart"
                      onClick={() =>
                        history.push("/Creditoycobranza/CondonacionInteres", {
                          idcliente: 0,
                          desdeDashboard: true,
                          permisos: sucursalesPermitidas,
                        })
                      }
                    >
                      <ChartCondonacionIntereses data={interesesCondonados} />
                    </div>

                    <div
                      className="chart quinto"
                      onClick={() =>
                        history.push("/Creditoycobranza/ClientesJuridico", {
                          permisos: sucursalesPermitidas,
                        })
                      }
                    >
                      <div className="chart-titulo">Clientes en jurídico</div>
                      <div className="chart-info">
                        <ChartClientesJuridico data={dataJuridico} />
                      </div>
                    </div>
                    <div
                      className="chart sexto"
                    // onClick={() =>
                    //   history.push(
                    //     "/Creditoycobranza/PlantillasKarbot"
                    //   )
                    // }
                    >
                      <div className="chart-titulo">
                        Porcentaje de recuperación de cartera
                      </div>
                      <div className="chart-info">
                        <ChartMensajesAutomaticos data={dataPorcRecuperacion} />
                      </div>
                    </div>
                  </>
                )}

                <div className="chart onceavo">
                  <div className="chart-titulo">Proyección de recuperación</div>
                  <div className="chart-info">
                    <ProyeccionMensualScreen
                      data={dataProyeccionLinea}
                      ejercicio={newEjercicio || boxstate.ejercicio}
                      periodo={newPeriodo || boxstate.periodo}
                      columnas={columnas}
                      permisos={sucursalesPermitidas}
                    />
                  </div>
                </div>
                <div
                  className="chart"
                  onClick={() => history.push("/Credito/CarteraTransito")}
                >
                  <div className="chart-titulo">Cartera en tránsito</div>
                  <div className="chart-info cartera-transito-content">
                    <div className="cartera-metric">
                      <span className="cartera-metric-label">Registros</span>
                      <span className={`cartera-metric-value ${Number(cartera_transito.registros || 0) === 0 ? "valor-ok" : "valor-alerta"}`}>
                        {Number(cartera_transito.registros || 0).toLocaleString("es-MX")}
                      </span>
                    </div>
                    <div className="cartera-metric-divider" />
                    <div className="cartera-metric">
                      <span className="cartera-metric-label">Saldo</span>
                      <span className={`cartera-metric-value cartera-metric-saldo ${Number(cartera_transito.saldo || 0) === 0 ? "valor-ok" : "valor-alerta"}`}>
                        ${Number(cartera_transito.saldo || 0).toLocaleString("es-MX", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </span>
                      {/* <span className="cartera-metric-note">miles de pesos</span> */}
                    </div>
                  </div>
                </div>
                {permiso === "Menu" && (
                  <div
                    className="chart quinto"
                    onClick={() =>
                      history.push("/Creditoycobranza/PlantillasKarbot")
                    }
                  >
                    <div className="chart-titulo">Mensajes</div>
                    <div className="chart-info">
                      <ChartMensajesAutomaticosOriginal data={dataMensajes} />
                    </div>
                  </div>
                )}
                {/* Préstamos clientes — datos de ejemplo hasta conectar endpoint */}
                <div
                  className="chart"
                  onClick={() =>
                    history.push("/Creditoycobranza/ReportePrestamosClientes")
                  }
                >
                  <div className="chart-titulo">Préstamos clientes</div>
                  <div className="chart-info prestamos-clientes-info">
                    <ChartPrestamosClientes data={prestamosClientes} />
                  </div>
                </div>
              </div>
            </>
          )}
      </div>
      <div className="header-notice">
        <span>
          (Todas las cifras de esta pantalla estan expresadas en miles de pesos)
        </span>
        <span>
          {ultimaActualizacion && ultimaActualizacion.length > 0
            ? `Ultima actualizacion: ${formatActualizacion(ultimaActualizacion[0])}`
            : "Sin actualizacion disponible"}
        </span>
      </div>
    </PlantillaScreen>
  );
};
